module.exports = __webpack_public_path__ + "static/img/img_jiejue_fangan_banner.500408ca.png";